import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { Redirect } from "react-router-dom";
import AppointmentOverview from './AppointmentOverview';
import SchedulingQuestions from './SchedulingQuestions';
import Spinner from '../common/spinner';
import Questionnaires from './Questionnaires';
import SectionLoadingError from "../common/SectionLoadingError";
import StickyProgressBar from '../common/StickyProgressBar';


const InHomeEligibility = ({ history, selectedVaccines, getEligibilityQPending, getEligibilityQResult, success, getQuestionnaires, sendQuestionnaires }) => {

    const [questionsData, setQuestionsData] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLastPatient, setIsLastPatient] = useState(false);
    const [inReverse, setInReverse] = useState(false);
    const questionnaireResponse = useRef([]);
    const removedVaccines = useRef({});

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingEligibility.Displayed`, new Date(), Tools.getURLPath());
        getQuestionnaires();
    }, [getQuestionnaires]);

    useEffect(() => {
        if (!getEligibilityQResult) return;
        setQuestionsData(getEligibilityQResult)
        setIsLastPatient(currentIndex === getEligibilityQResult.length - 1)
    }, [getEligibilityQResult])


    const onPrevious = () => {
        if (currentIndex === 0) {
            history.push("/inhomeschedule/s4")
        } else {
            setCurrentIndex(currentIndex - 1)
            setInReverse(true);
        }
    }

    const saveResponse = (questionResponse) => {
        let temp = [...questionnaireResponse.current];
        questionnaireResponse.current = temp.concat(questionResponse);
    }

    const onNext = (questionResponse) => {
        if (currentIndex === questionsData.length - 1) {
            sendResponse(questionResponse);
            history.push("/inhomeschedule/s6")

        } else {
            if (questionResponse.length) saveResponse(questionResponse)
            if (currentIndex + 1 === questionsData.length - 1) setIsLastPatient(true);
            setCurrentIndex(currentIndex + 1)
            setInReverse(false);
        }
    }

    const sendResponse = (questionResponse) => {
        if (questionResponse.length) saveResponse(questionResponse);
        sendQuestionnaires(questionnaireResponse.current)
    }

    const setVaccineIsRemoved = (mrn, vaccineName) => {
        if (removedVaccines.current[mrn]) {
            removedVaccines.current[mrn].push(vaccineName)
        } else {
            removedVaccines.current[mrn] = [vaccineName];
        }
    }

    return (
        <>
            {!selectedVaccines || selectedVaccines.length < 1 ? <Redirect to='/inhomeschedule/s4' /> :
                <>
                    <StickyProgressBar className="inhome" widthInPercent={2 / 3 * 100} />
                    <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="row flex">
                                    <div className="in-home-left-panel scheduling-wrapper">
                                        <div className="detail-wrapper eligibility-detail-wrapper">
                                            <h1 className="page-heading">Before you proceed</h1>
                                            {getEligibilityQPending && <Spinner />}
                                            {!getEligibilityQPending && !success && <SectionLoadingError message="Failed to load. Please try again" />}
                                            {!getEligibilityQPending &&
                                                questionsData && questionsData.map((user, index) => {
                                                    return index === currentIndex && <div key={`user-${index}`}>
                                                        <p className="subheading-info">Check any of the statements below that apply to
                                                            <b className="patient-name-date"> {user.patient.firstName} {user.patient.lastName} ({user.patient.dob}). </b></p>
                                                        <Questionnaires
                                                            isLastPatient={isLastPatient}
                                                            questions={user.questions}
                                                            dictionary={user.dictionary}
                                                            mrn={user.patient.mrn}
                                                            onNext={onNext}
                                                            onPrevious={onPrevious}
                                                            history={history}
                                                            inReverse={inReverse}
                                                            firstName={user.patient.firstName}
                                                            selectedVaccines={selectedVaccines}
                                                            setVaccineIsRemoved={setVaccineIsRemoved}
                                                            removedVaccines={removedVaccines.current}
                                                            sendResponse={sendResponse}
                                                        />
                                                    </div>
                                                })
                                            }
                                        </div>
                                        <SchedulingQuestions />
                                    </div>
                                    <div className="in-home-right-panel">
                                        <AppointmentOverview eligibilityPhase={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
}
const mapStateToProps = state => {

    return {
        selectedVaccines: state.inHome.selectedVaccines,
        getEligibilityQPending: state.inHome.getEligibilityQPending,
        getEligibilityQResult: state.inHome.getEligibilityQResult?.data || null,
        success: state.inHome.getEligibilityQResult?.success || null,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getQuestionnaires: () => {
            dispatch({ type: types.GET_INHOME_ELIGIBILITY_Q })
        },
        sendQuestionnaires: (response) => {
            dispatch({ type: types.SEND_INHOME_ELIGIBILITY_RESPONSES, response })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeEligibility);